import axios from 'axios';

// baseURL rỗng → request relative tới origin hiện tại.
// webpack-dev-server (3002) sẽ proxy mọi /api/* sang Express (3001).
// Cách này giữ Basic Auth same-origin nên browser cache & gửi header tự động.
const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Log API
export const logAPI = {
    getLogs: (params) => api.get('/api/logs', { params }),
    getLogById: (id) => api.get(`/api/logs/${id}`),
    getPlayerLogs: (steamId, params) => api.get(`/api/logs/player/${steamId}`, { params }),
    searchLogs: (data) => api.post('/api/logs/search', data),
    exportLogs: (params) => api.get('/api/logs/export/csv', { params, responseType: 'blob' }),
    getActionSummary: () => api.get('/api/logs/summary/actions'),
    suggestPlayers: (q) => api.get('/api/logs/suggest/players', { params: { q } })
};

// Channel API
export const channelAPI = {
    getGroups: () => api.get('/api/channels/groups'),
    getGroupLogs: (groupKey, params) => api.get(`/api/channels/group/${groupKey}`, { params }),
    getChannelLogs: (channelKey, params) => api.get(`/api/channels/channel/${channelKey}`, { params }),
    getChannelMap: () => api.get('/api/channels/map')
};

// FiveM Logs API
export const fivemLogAPI = {
    getLogs:    (params) => api.get('/api/fivem-logs', { params }),
    getSummary: ()       => api.get('/api/fivem-logs/summary'),
    getAdminSummary: (params) => api.get('/api/fivem-logs/admin-summary', { params }),
    getPlayer:  (citizenId, params) => api.get(`/api/fivem-logs/player/${citizenId}`, { params }),
    getModShiftSummary: (params) => api.get('/api/fivem-logs/modshift-summary', { params }),
};

// Inventory History API — lịch sử mở kho đồ
export const inventoryHistoryAPI = {
    list:     (citizenId, params) => api.get(`/api/inventory-history/${citizenId}`, { params }),
    snapshot: (id)                => api.get(`/api/inventory-history/snapshot/${id}`),
};

// Players API — danh sách người chơi + leaderboard
export const playersAPI = {
    list:        (params) => api.get('/api/players', { params }),
    topRichest:  (params) => api.get('/api/players/top-richest', { params }),
};

// Auth — current user info (role)
export const authAPI = {
    me: () => api.get('/api/auth/me'),
};

// Transfer-Duplication Exploit Alerts API
export const transferAlertsAPI = {
    list:    (params) => api.get('/api/transfer-alerts', { params }),
    summary: ()       => api.get('/api/transfer-alerts/summary'),
};

// Job Abuse Alerts API — 3 rule types: compound, rapid_reward, dup_reward
export const jobAbuseAlertsAPI = {
    list:    (params) => api.get('/api/job-abuse-alerts', { params }),
    summary: ()       => api.get('/api/job-abuse-alerts/summary'),
    scan:    ()       => api.post('/api/job-abuse-alerts/scan'),
    scanAll: ()       => api.post('/api/job-abuse-alerts/scan-all'),
};

// Stats API
export const statsAPI = {
    getOverview: (params) => api.get('/api/stats/overview', { params }),
    getHourlyActivity: () => api.get('/api/stats/activity/hourly'),
    getDailyActivity: () => api.get('/api/stats/activity/daily'),
    getTopPlayers: (params) => api.get('/api/stats/players/top', { params }),
    getActionDistribution: (params) => api.get('/api/stats/actions/distribution', { params }),
    getAnticheatStats: (params) => api.get('/api/stats/anticheat', { params }),
    getMoneyBalances: (params) => api.get('/api/stats/money/balances', { params }),
    getPlayerCombat: (params) => api.get('/api/stats/player-combat', { params }),
};

export default api;
